// https://vuex.vuejs.org/en/mutations.html#using-constants-for-mutation-types

const types = [
  'tariffOptions',
  'comprehensive',
  'lastVisit',
  'initialRegistrationYear',
  'typeCertificateNumber',
  'brand',
  'model',
  'fuelTypeId',
  'fuelTypeName',
  'vehicleCategory',
  'vehicleCategoryName',
  'vehiclePower',
  'vehicleDoors',
  'transmission',
  'transmissionName',
  'vehiclePowerRange',
  'vehicleId',
  'vehicleType',
  'vehicleCategoryType',
  'vehicleRegistrationType',
  'canton',
  'ownedSince',
  'businessUsage',
  'transport',
  'vehiclePrice',
  'leasing',
  'nationality',
  'nationalityName',
  'residencePermit',
  'driverLicenceSinceYear',
  'isKeeperMainDriver',
  'isDriverTooYoung',
  'claims',
  'agentEmail',
  'customerDocuments',
  'consultationProtocol',
  'consultationProtocolFileName',
  'keepExistingConsultationProtocol',
  'invoices',
  'reminders',
  'emails',
  'genderOfTooYoungDriver',
  'youngDriver',
  'driverLicenceWithdrawal',
  'tooManyAccidents',
  'gender',
  'firstName',
  'lastName',
  'street',
  'houseNumber',
  'zip',
  'city',
  'email',
  'phone',
  'dateOfBirth',
  'age',
  'company',
  'uid',
  'industry',
  'startOfInsurance',
  'productPrice',
  'productKey',
  'productVersionId',
  'productVersionKey',
  'productName',
  'productHeadline',
  'productVersion',
  'productDocuments',
  'productElementals',
  'customized',
  'declinedReason',
  'newContractId',
  'originalProposalId',
  'contractStatus',
  'renewalOfferingContractId',
  'paymentInterval',
  'customerType',
  'searchmode',
  'nationalitySwiss',
  'nationalityOthers',
  'serialNumber',
  'registeredToDextra',
  'licencePlateRegisteredToOwner',
  'vehicleRegisteredToOwner',
  'licencePlateActive',
  'licencePlate',
  'licencePlateAvailable',
  'truckExtEquipmentPrice',
  'truckIntEquipmentPrice',
  'productDetails',
  'applicationIdentifier',
  'billingModel',
  'whitelabelPartnerKey',
]

const mutationTypes = {
  SET_AUTHENTICATION: 'SET_AUTHENTICATION',
  RESET_AUTHENTICATION: 'RESET_AUTHENTICATION',
  AUTHENTICATE_AGENT: 'AUTHENTICATE_AGENT',
  SET_AGENTDETAILS: 'SET_AGENTDETAILS',
  SET_WHITELABEL_DETAILS: 'SET_WHITELABEL_DETAILS',
  RESET_AGENT: 'RESET_AGENT',
}

types.forEach((type) => {
  const mutationType = `SET_${type.toUpperCase()}`
  mutationTypes[type] = mutationType
})

export default mutationTypes
